import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { animateCss } from "../../../pages/TosterAlert";
import {
  allUserRoleRouteAction,
  getUsersRoleRouterAction,
  newUserRoleRouteAction,
  singleUserRoleRouteAction,
  updateUserRoleRouteAction,
  createRoleRouteItemAction,
  updateRoleRouteItemAction,
  getAllRoleRouteItemsAction,
} from "../../actions/UserRouters/UserRoleRouteAction";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const userRoleRouteSliceIntial = {
  route: [],
  landingPage: [],
  allRoleRoute: [],
  editUserRole: [],
  newUserRole: [],
  listLoading: false,
  createRoleRoute: {
    loading: false,
    error: "",
  },
  list: [],
  loading: false,
  create: {
    loading: false,
    error: "",
  },
  update: {
    loading: false,
    error: "",
  }
};

const usersRoleRouteSlice = createSlice({
  name: "userRoleRouters",
  initialState: userRoleRouteSliceIntial,
  reducers: {
    resetRoleRoute: (state, { payload }) => {
      state = userRoleRouteSliceIntial;
      return state;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getUsersRoleRouterAction.pending, (state, { payload }) => {
        state.loading = true;
      })
      .addCase(getUsersRoleRouterAction.fulfilled, (state, action) => {
        state.loading = false;
        state.route = action.payload?.data;
        state.landingPage = action.payload?.landingPage;
        return state;
      })
      .addCase(getUsersRoleRouterAction.rejected, (state, action) => {
        const navigate = useNavigate();
        navigate("/");
        state.loading = false;
        return state;
      })
      .addCase(allUserRoleRouteAction.pending, (state, { payload }) => {
        state.loading = true;
      })
      .addCase(allUserRoleRouteAction.fulfilled, (state, action) => {
        state.loading = false;
        state.allRoleRoute = action.payload;
        return state;
      })
      .addCase(allUserRoleRouteAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(singleUserRoleRouteAction.pending, (state, { payload }) => {
        state.loading = true;
      })
      .addCase(singleUserRoleRouteAction.fulfilled, (state, action) => {
        state.loading = false;
        state.editUserRole = action.payload;
        return state;
      })
      .addCase(singleUserRoleRouteAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateUserRoleRouteAction.pending, (state, { payload }) => {
        state.loading = true;
      })
      .addCase(updateUserRoleRouteAction.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.data) {
          animateCss("success", "Updated Successfully");
        } else if (!action.payload.data) {
          animateCss("error", "Role Route Not Update");
        }

        return state;
      })
      .addCase(updateUserRoleRouteAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(newUserRoleRouteAction.pending, (state, { payload }) => {
        state.loading = true;
      })
      .addCase(newUserRoleRouteAction.fulfilled, (state, action) => {
        state.loading = false;
        state.newUserRole = action.payload?.data;
        return state;
      })
      .addCase(newUserRoleRouteAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getAllRoleRouteItemsAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllRoleRouteItemsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload?.data || [];
      })
      .addCase(getAllRoleRouteItemsAction.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createRoleRouteItemAction.pending, (state) => {
        state.create.loading = true;
      })
      .addCase(createRoleRouteItemAction.fulfilled, (state, action) => {
        state.create.loading = false;

        if (action.payload?.success) {
          animateCss("success", "Route Item Created Successfully");
          state.list.unshift(action.payload.data);
        } else {
          // animateCss("error", action.payload?.message || "Create failed");
          console.error("Route Item Creation Error",action.payload?.message);
        }
      })
      .addCase(createRoleRouteItemAction.rejected, (state, action) => {
        state.create.loading = false;
        state.create.error = action.payload;
      })
      .addCase(updateRoleRouteItemAction.pending, (state) => {
        state.update.loading = true;
      })
      .addCase(updateRoleRouteItemAction.fulfilled, (state, action) => {
        state.update.loading = false;

        if (action.payload?.success) {
          animateCss("success", "Route Item Updated Successfully");

          const index = state.list.findIndex(
            (item) => item.id === action.payload.data.id
          );

          if (index !== -1) {
            state.list[index] = action.payload.data;
          }
        } else {
          // animateCss("error", action.payload?.message || "Update failed");
          console.error("Route Item Update Error",action.payload?.message);
        }
      })
      .addCase(updateRoleRouteItemAction.rejected, (state, action) => {
        state.update.loading = false;
        state.update.error = action.payload;
      }),
});

export const { resetRoleRoute } = usersRoleRouteSlice.actions;
export default usersRoleRouteSlice.reducer;
